import React, { useEffect, useRef, useState } from 'react';
import Box, { BoxProps } from 'ui-box';
import { useDebouncedCallback } from 'use-debounce/lib';
import { defaultFills } from './Colors';
import { InputGroup } from './InputGroup';

export const SearchInput = ({
  onSearch,
  currentQuery,
  ...props
}: BoxProps<'div'> & {
  onSearch: (query: string) => void;
  currentQuery: string;
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [focussed, setFocussed] = useState(false);
  const active = focussed || (inputRef.current && inputRef.current.value);

  const [query, setQuery] = useState(currentQuery);

  useEffect(() => {
    if (!currentQuery && inputRef.current) {
      setQuery('');
    }
  }, [currentQuery]);

  const handleOnSearch = useDebouncedCallback((query: string) => {
    onSearch(query);
  }, 200);

  return (
    <Box
      maxWidth={active ? '300px' : '120px'}
      width="100%"
      {...props}
      transition="0.2s max-width"
    >
      <InputGroup
        ref={inputRef}
        placeholder="Search"
        marginBottom={0}
        iconLeft="search"
        fill
        size={0}
        onFocus={() => setFocussed(true)}
        value={query}
        onChange={(e) => {
          setQuery(e.target.value);
          handleOnSearch.callback(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleOnSearch.flush();
          }
        }}
        onBlur={(e) => {
          setFocussed(false);
          handleOnSearch.flush();
        }}
        iconColor={focussed ? defaultFills.info[500] : undefined}
      />
    </Box>
  );
};
